// extracted by mini-css-extract-plugin
module.exports = {"page_header":"CrmContextPage_page_header__1T0tr"};